/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { REMOVE_GROUP_COURSE } from "./actionTypes"
import { apiError, removeGroupCourseSuccess } from "./actions"

//Include Both Helper File with needed methods
import { deleteGroupCourse } from "../../../helpers/backend_helper"

function* remove(action) {
  try {
    const response = yield call(deleteGroupCourse, action.payload.form)
    if (response == undefined) throw new Error("API error")
    if (!response.success) throw new Error("Error al agregar el curso")
    yield put(removeGroupCourseSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(apiError(error.message))
  }
}

function* groupCourseRemoveSaga() {
  yield takeEvery(REMOVE_GROUP_COURSE, remove)
}

export default groupCourseRemoveSaga
